module.exports = __webpack_public_path__ + "img/icon_bg10.0636e3f7.png";